import { render, staticRenderFns } from "./Order_List.vue?vue&type=template&id=bf14c0f4&scoped=true&"
import script from "./Order_List.vue?vue&type=script&lang=js&"
export * from "./Order_List.vue?vue&type=script&lang=js&"
import style0 from "./Order_List.vue?vue&type=style&index=0&id=bf14c0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf14c0f4",
  null
  
)

export default component.exports